import React, { useCallback, useEffect, useRef, useState } from "react";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
import { useInView } from "react-intersection-observer";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { uploadAccLogo } from "../../../../Redux/actions";
import { checkNull } from "../../../../helpers";
import CropperModel from "../../../Components/CropperModel";
import Sales from "./GeneralSettings/Sales";
import Settings from "./GeneralSettings";
import Holidays from "./GeneralSettings/Holidays";
import MasterSettings from "./GeneralSettings/MasterSettings";

const GeneralSetting = (params) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { finance_general_details } = useSelector(
    (state) => state.settingReducer
  );

  const [tab, setTab] = useState("general"); //general

  /* upload logo */
  const [selectedFile, setSelectedFile] = useState(null);
  const [cropperModal, setCropperModal] = useState(false);

  const closeCropModal = useCallback(
    (value) => {
      setCropperModal(value);
    },
    [cropperModal]
  );

  const saveCroppedImage = useCallback((value) => {
    dispatch(uploadAccLogo({ file: value }, "finance"));
    closeCropModal(false);
  }, []);

  const onFileChangeEvent = (event) => {
    if (event?.target?.files[0]) {
      setSelectedFile(event.target.files[0]);
      closeCropModal(true);
      event.target.value = null;
    }
  };

  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content row mx-0">
          <div className="container px-0">
            <div className="finance-setting-chart account-detail general-setting">
              <div className="row top-logos">
                <figure className="uploaded-logo col-2">
                  <span className="img_cloog">
                    <img
                      src={
                        checkNull(
                          finance_general_details?.merchant_data?.logo,
                          false
                        )
                          ? finance_general_details?.merchant_data?.logo
                          : "/img/logo555.png"
                      }
                      id="mlogo"
                    />
                  </span>
                </figure>
                <div className="col-6 d-flex align-content-center flex-wrap">
                  <h4 className="mb-0"> Harry's HQ </h4>
                  <div className="input-group shift_action ">
                    <label
                      className="upload-icon upload-logo uploadlogo"
                      for="staff_file"
                    >
                      {" "}
                      <span> Upload logo</span>
                      <input
                        type="file"
                        name="staff_file"
                        id="staff_file"
                        className="inputfile inputfile-2"
                        data-multiple-caption="{count} files selected"
                        onChange={onFileChangeEvent}
                      />
                    </label>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="tab-section">
                  <div className="nav nav-tabs" id="nav-tab">
                    <button
                      className={`nav-link${tab == "general" ? " active" : ""}`}
                      id="nav-home-tab"
                      type="button"
                      onClick={() => setTab("general")}
                    >
                      GENERAL
                    </button>
                    <button
                      className={`nav-link${tab == "sale" ? " active" : ""}`}
                      id="nav-profile-tab"
                      type="button"
                      onClick={() => setTab("sale")}
                    >
                      SALES
                    </button>
                    <button
                      className={`nav-link${tab == "holiday" ? " active" : ""}`}
                      id="nav-contact-tab"
                      type="button"
                      onClick={() => setTab("holiday")}
                    >
                      PUBLIC HOLIDAYS
                    </button>

                    <button
                      className={`nav-link${tab == "master" ? " active" : ""}`}
                      id="nav-mastersetting-tab"
                      type="button"
                      onClick={() => setTab("master")}
                    >
                      Master Settings
                    </button>
                  </div>
                </div>
              </div>

              <div className="tab-content" id="nav-tabContent">
                {tab == "general" && <Settings />}
                {tab == "sale" && <Sales />}
                {tab == "holiday" && <Holidays />}
                {tab == "master" && <MasterSettings />}
              </div>
            </div>
          </div>
        </div>
      </div>
      <CropperModel
        open={cropperModal}
        submitModal={saveCroppedImage}
        closeModal={closeCropModal}
        is_loading={false}
        selectedFile={selectedFile}
      />
    </UserInterface>
  );
};
export default GeneralSetting;
